import { ApolloClient } from 'apollo-client';
import { ApolloLink } from 'apollo-link';
import { HttpLink } from 'apollo-link-http';
import { NormalizedCacheObject, InMemoryCache } from 'apollo-cache-inmemory';
import { CachePersistor } from 'apollo-cache-persist';
import { authLink, retryAnalyticsLink } from 'services';
import { graphqlApiUrl, appVersion } from 'helpers/constants';
import { AsyncStorage } from 'services/asyncStorage';
import { fragmentMatcher, dataIdFromObject, storage } from 'services/apollo/client';
import { monitorAnalyticsLink } from '../links/monitorLink';

const convertGraphqlErrorToNetworkErrorLink = new ApolloLink((operation, forward) => {
  return forward(operation).map((data) => {
    if (data && data.errors && data.errors.length > 0) {
      throw new Error('GraphQL Error');
    }
    return data;
  });
});

const analyticsCache = new InMemoryCache({
  fragmentMatcher,
  dataIdFromObject,
});

export const analyticsPersistor = new CachePersistor({
  key: 'apollo-cache-persist',
  cache: analyticsCache,
  storage: storage,
  trigger: false,
});

export const getAnalyticsClient = async () => {
  const httpLink = new HttpLink({ uri: graphqlApiUrl });

  const link = ApolloLink.from([
    monitorAnalyticsLink,
    retryAnalyticsLink,
    convertGraphqlErrorToNetworkErrorLink,
    authLink,
    httpLink,
  ]);

  const cacheVersion = await AsyncStorage.get('apollo-cache-version');

  if (appVersion !== cacheVersion) {
    await analyticsPersistor.purge();
  } else {
    await analyticsPersistor.restore();
  }

  return new ApolloClient<NormalizedCacheObject>({ link, cache: analyticsCache });
};
